@if (initialized && contractsRuntime) {

  <div class="mx-auto surface-section lg:px-5 px-3 py-3 border-round-lg">
    <div class="card mb-5 p-0">
      <div class="p-5">
        <h3 class="text-color">Dokumente</h3>
        <p class="text-color-secondary mb-5">Auf dieser Seite findest du alle Dokumente zu deinem Maklervertrag und der Maklervollmacht.</p>
      </div>
    </div>

    <ds-documents></ds-documents>

  </div>




}

